// @flow

import React, { type Node } from 'react';

export function UberV2Loading(): Node {
  return <p>Loading…</p>;
}
